import NavBar from "@/components/organisms/NavBar";
import Footer from "@/components/organisms/Footer";
import LpSection from "@/components/organisms/LpSection";
import MissionSection from "@/components/organisms/MissionSection";

export default function AboutPage() {
  return (
    <div className="bg-white">
      <NavBar />
      <div className="bg-gradient-blue-primary-120 min-h-screen">
        <div className="mt-[5%]">
          <LpSection />
          <MissionSection />
        </div>
      </div>
      <div className="mt-8">
        <Footer />
      </div>
    </div>
  );
}
